export default (fullname = "") => {
  const names = fullname.trim().split(" ");
  return {
    fname: names[0],
    lname: names.slice(1).join(" ")
  };
};
